import { StatusCodes } from "http-status-codes";

import { headers } from "../../../config/config";
import { request } from "../api";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";
import { ProvidersInformationMinimized } from "../../../@types/components/provider.types";

const { patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "providers";

type ProviderProvidersByTaxIdPayload = ProvidersInformationMinimized;

export const updateProviderByTaxId = async (_payload: ProviderProvidersByTaxIdPayload, group_number: number) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/update-providersByTaxID?group_number=${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;

			if (message === MESSAGE.patch.succ) return message;
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		// console.log("error message", error);
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { err } = error.response.data;
			throw err;
		}
	}
};
